import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

/** Dezelfde grens als de onderbalk en styles.scss. */
export const TELEFOON = '(max-width: 767.98px)';

/**
 * Op de telefoon begint de console bij Status (Clubstats), niet bij het
 * dashboard (eigenaar 15-10-2026). Het dashboard is een raster van acht
 * tegels en snelkoppelingen naar pagina's die op de telefoon niet staan; wie
 * de console op zijn iPhone opent wil weten of de vloot draait.
 *
 * Alleen het dashboard krijgt deze guard. Elke andere link opent gewoon wat
 * hij belooft, ook op de telefoon.
 */
export const telefoonStartGuard = (): boolean | UrlTree => {
  const telefoon = typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(TELEFOON).matches;
  return telefoon ? inject(Router).createUrlTree(['/clubs-stats']) : true;
};
